<frodo-spinner
  *ngIf="isLoading$ | async"
  [colorSpinner]="spinnerConfig.colorSpinner"
  [src]="spinnerConfig.src"
  [diameter]="spinnerConfig.diameter"
  [strokeWidth]="spinnerConfig.strokeWidth"
  [spinnerType]="spinnerConfig.spinnerType"
  class="spinner"
>
</frodo-spinner>

<section
  class="mobile-layout"
  [ngClass]="{ loading: isLoading$ | async }"
  [attr.inert]="(isLoading$ | async) ? '' : null"
  [attr.aria-busy]="(isLoading$ | async) ? 'true' : null"
>
  <header class="mobile-layout__header">
    <button *ngIf="!isBackButtonDisabled" (click)="onGoBack()">
      <span class="mobile-layout__header__back-icon material-icons"> chevron_left </span>
    </button>
    <frodo-title [text]="title | translate"></frodo-title>
  </header>

  <main class="mobile-layout__content">
    <router-outlet></router-outlet>
  </main>

  <footer class="mobile-layout__footer">
    <frodo-logo
      class="mobile-layout__footer__logo"
      [src]="apexlogoUrl"
      [showTitle]="true"
      [textPosition]="'top'"
      [alt]="'logo'"
    ></frodo-logo>
  </footer>
</section>
